import { useEffect, useState, useRef } from 'react';
//import { Link } from 'react-router-dom';

import { isMobile } from 'react-device-detect';
import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { mypageData } from '../../components/Tab/TabData';

import Table from '../../components/Table/Table';
import Pagination from 'react-js-pagination';
import useScreenSize from '../../hooks/useScreenSize';
import { Button } from '../../components/Button/Button';
import Modal, { useToggleModal } from '../../components/Modal/Modal';
import Certificate from '../../components/Certificate';

import { fetchGet, fetchPut } from '../../hooks/fetch';
import { EducationStatus } from './UserEnum';
import Loading from '../Loading';

export default function MyEdu() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const [posts, setPosts] = useState([]); // 전체 게시글 데이터
	const [pagingInfo, setPagingInfo] = useState({ totalCount: 0, totalPage: 0 });
	const [page, setPage] = useState(1); // 현재 페이지 번호
	const postPerPage = 10; // 페이지 당 게시글 갯수

	// th 총 갯수 (등록된 내용이 없는 경우 병합)
	const columnRef = useRef(null);
	const [columnSize, setColumnSize] = useState(5);

	const [certification, setCertification] = useState({});
	const [selectedEdu, setSelectedEdu] = useState(0);

	const handlePageChange = (page) => {
		setPage(page);
	};

	const screenSize = useScreenSize();
	const pageName = '내 교육';
	const toggleModal = useToggleModal();

	function getPage() {
		fetchGet(
			`/mypage/education`,
			(json) => {
				setPosts(json.dataList);
				setPagingInfo(json.pagingInfo);
				setIsLoading(false);
			}
		)
	}

	const openCertificateMd = (uid) => {
		getCertification(uid);
		toggleModal.open({ name: "certificate-modal" });
	}

	function getCertification(uid) {
		fetchGet(
			`/mypage/education/${uid}`,
			(json) => setCertification(json)
		)
	}

	const openCancelMd = (uid) => {
		toggleModal.open({ name: "check-form-dialog" });
		setSelectedEdu(uid);
	}

	function cancelEducation() {
		fetchPut(
			`/mypage/education/${selectedEdu}`,
			"교육 신청을 취소",
			{},
			() => window.location.reload()
		);
	}

	function closeMd() {
		setSelectedEdu(0);
		toggleModal.close();
	}

	useEffect(() => {
		setIsLoading(true);
		getPage();
	}, [page]);

	return (
		<main id="mypage-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={mypageData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						{isMobile && (
							<p className="gs-bullet asterisk fc-cerulean-blue mb-10 fs-14">
								pc로 접속하면 수료증 인쇄를 할 수 있습니다.
							</p>
						)}
						<Table
							caption="내 교육 내역 목록입니다. 교육명, 교육기간, 신청일, 상태를 제공합니다."
							responsive="900"
							className="my-edu-list-con bg-header"
						>
							<colgroup>
								<col />
								<col style={{ width: '200px' }} />
								<col style={{ width: '170px' }} />
								<col style={{ width: '100px' }} />
								<col style={{ width: '90px' }} />
							</colgroup>
							<thead>
								<tr ref={columnRef}>
									<th>교육명</th>
									<th>교육기간</th>
									<th>신청일</th>
									<th>상태</th>
									<th>기타</th>
								</tr>
							</thead>
							<tbody className="center">
								{isLoading ? <Loading /> : pagingInfo?.totalCount === 0 ? (
									<tr>
										<td colSpan={columnSize}>
											<div className="gs-no-con">등록된 내용이 없습니다.</div>
										</td>
									</tr>
								) : (
									posts?.map((post) => (
										<tr key={post.rowId} className="fs-14">
											<td data-th="교육명" className="ta-left">
												{post.educationName}
												{/* <Link className="gs-underline-item effect">
													<span className="line">{post.교육명}</span>
												</Link> */}
											</td>
											<td data-th="교육기간">{post.educationPeriod}</td>
											<td data-th="신청일">{post.appliedDate}</td>
											<td
												data-th="상태"
												className={EducationStatus[post?.status.en]?.class}
											>
												{EducationStatus[post?.status.en]?.kr}
											</td>

											{post.status?.en === 'EDU_BEFORE' ? (
												<td data-th="기타">
													<Button
														type="button"
														className="xs mg-auto orange"
														onClick={() => openCancelMd(post?.uid)}
													>
														취소
													</Button>
												</td>
											) : post.status?.en === 'COMPLETE' ? (
												<td data-th="기타">
													<Button
														type="button"
														className="xs mg-auto"
														onClick={() => openCertificateMd(post?.uid)}
													>
														수료증
													</Button>
												</td>
											) : (
												<td data-th="기타"></td>
											)}
										</tr>
									))
								)}
							</tbody>
						</Table>

						{pagingInfo.totalCount > 0 && (
							<Pagination
								innerClass="gs-pagination"
								// itemClass="pg-item"
								linkClass="btn"
								itemClassFirst="pg-arrow pg-first"
								itemClassPrev="pg-arrow pg-prev"
								itemClassNext="pg-arrow pg-next"
								itemClassLast="pg-arrow pg-last"
								firstPageText={null} // 첫 번째 페이지 탐색 버튼의 텍스트
								prevPageText={null} // 이전 페이지 탐색 버튼의 텍스트
								nextPageText={null} // 다음 페이지 탐색 버튼의 텍스트
								lastPageText={null} // 마지막 페이지 탐색 버튼의 텍스트
								activePage={page} // 현재 페이지
								totalItemsCount={pagingInfo.totalCount} // 총 아이템 갯수
								itemsCountPerPage={postPerPage} // 한 페이지랑 보여줄 아이템 갯수
								pageRangeDisplayed={screenSize.width >= 480 ? 5 : 3} // paginator의 페이지 범위 (useScreenSize custom hook 사용)
								onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
							/>
						)}
					</div>
				</div>
			</Container>

			{/* 신청한 교육 취소 확인 팝업 */}
			{toggleModal.modal?.name === 'check-form-dialog' && (
				<Modal ariaLabelledby="check-form-dialog" handleOpenModal={closeMd} className="dialog">
					<Modal.Header>기술사업화지원센터</Modal.Header>
					<Modal.Body className="center">신청하신 교육을 취소하시겠습니까?</Modal.Body>
					<Modal.Footer>
						<Button
							type="button"
							className="gray"
							onClick={closeMd}
						>
							<strong>아니오</strong>
						</Button>
						<Button type="button" onClick={cancelEducation}>
							<strong>예</strong>
						</Button>
					</Modal.Footer>
				</Modal>
			)}

			{/* 수료증 팝업 */}
			{toggleModal.modal?.name === 'certificate-modal' && (
				<Modal ariaLabelledby="certificate-modal" handleOpenModal={closeMd}>
					<Modal.Body>
						<Certificate
							name={certification?.name}
							eduInfos={[
								certification?.title,
								certification?.period,
								// certification?.company 임시
								"기술사업화지원센터"
							]}
							date={certification?.certificatedDate}
						/>
					</Modal.Body>
				</Modal>
			)}
		</main>
	);
}
